import { render, staticRenderFns } from "./accountCard.vue?vue&type=template&id=18f83aa4&scoped=true"
import script from "./accountCard.vue?vue&type=script&lang=js"
export * from "./accountCard.vue?vue&type=script&lang=js"
import style0 from "./accountCard.vue?vue&type=style&index=0&id=18f83aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f83aa4",
  null
  
)

export default component.exports